__webpack_require__.p = "https://sports.whcdn.net/football/build-yourodds/com/en-gb/desktop/0.42.16/";